// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"ef3fadeb","453":"dab362cc","455":"01592c2e","977":"91686256"}[chunkId] + ".chunk.js";
};